import * as React from 'react';
import { useSelector } from 'react-redux';

import { getTitle } from './utils';
import { SubscriptionAuthorTitle } from '../../../components/subscriptionBrand';
import { selectAgencyName } from '../../../selectors';
import { selectAgencyUrl, selectIsSubAgent } from '../../../selectors/offerData/agent';
import { trackGoToAgentCard } from '../SubscriptionAuthorBrand/tracking';

export const SubscriptionAuthorTitleContainer = () => {
  const isSubAgent = useSelector(selectIsSubAgent);
  const agencyName = useSelector(selectAgencyName);
  const agencyUrl = useSelector(selectAgencyUrl);

  const title = getTitle(isSubAgent);

  const agency = isSubAgent && (
    <>
      {'・'}
      {!agencyUrl && agencyName}
      {!!agencyUrl && (
        <a
          href={agencyUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={trackGoToAgentCard('to_realtorCard_name')}
        >
          {agencyName}
        </a>
      )}
    </>
  );

  return <SubscriptionAuthorTitle title={title} agency={agency} />;
};
